






/**
 * This component was taken from https://codepen.io/dannielhugo/pen/KKVNROY
 * and ported to TS
 * */
import Vue from 'vue';

export default Vue.extend({
  name: 'HPokeballLoading',
});
